<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    import { onMount } from 'svelte';

    export let open = false;
    export let disabled = false;
    export let handleClear: (e: Event) => void;
    export let handleConfirm: (e: Event) => void;
    export let setConfirmButtonRef: (ref: HTMLButtonElement) => void;
    export let setClearButtonRef: (ref: HTMLButtonElement) => void;
    export let btnClearLabel = '',
        btnConfirmLabel = '';

    let confirmRef: HTMLButtonElement | undefined;
    let clearRef: HTMLButtonElement | undefined;

    onMount(() => {
        if (confirmRef) {
            setConfirmButtonRef(confirmRef);
        }

        if (clearRef) {
            setClearButtonRef(clearRef);
        }
    });

    const borderRadius = getBorderRadius('button');

    const buttonClasses = `${borderRadius} focus:before:${borderRadius} fun-relative fun-flex-1 fun-h-12 fun-outline-none fun-transition fun-duration-150 fun-font-bold fun-text-sm focus:before:fun-content-[""] focus:before:fun-absolute focus:before:fun--top-0.5 focus:before:fun--right-0.5 focus:before:fun--left-0.5 focus:before:fun--bottom-0.5 focus:before:fun-border focus:before:fun-border-blue-600 disabled:fun-opacity-70`;
    const clearButtonClasses = `${buttonClasses} fun-text-gray-500 fun-bg-gray-100 hover:fun-text-gray-600 hover:fun-bg-gray-200 disabled:hover:fun-bg-gray-100 disabled:hover:fun-text-gray-500`;
    const confirmButtonClasses = `${buttonClasses} fun-bg-blue-500 fun-text-white hover:fun-bg-blue-600 disabled:hover:fun-bg-blue-500`;
</script>

<div class="fun-flex fun-gap-2 fun-p-4 fun-pt-0">
    <button
        {disabled}
        class={clearButtonClasses}
        bind:this={clearRef}
        on:click={handleClear}
        tabindex={open ? 0 : -1}>{btnClearLabel}</button
    >
    <button
        {disabled}
        class={confirmButtonClasses}
        bind:this={confirmRef}
        on:keydown={(event) => {
            if (event.key === 'Tab' && !event.shiftKey) {
                event.preventDefault();
            }
        }}
        on:click={handleConfirm}
        tabindex={open ? 0 : -1}>{btnConfirmLabel}</button
    >
</div>
